let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f3xe1")).then(() => parcelRequire('btGRq'));